import { IconProps } from "../types";

export const ClientListIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M13.8333 1.83337H3.16667C2.76667 1.83337 2.5 2.10004 2.5 2.50004V14.5C2.5 14.9 2.76667 15.1667 3.16667 15.1667H13.8333C14.2333 15.1667 14.5 14.9 14.5 14.5V2.50004C14.5 2.10004 14.2333 1.83337 13.8333 1.83337ZM13.1667 13.8334H3.83333V3.16671H13.1667V13.8334ZM11.8333 11.9667H10.5V9.30004H11.8333V11.9667ZM9.16667 7.70004H7.83333V5.03337H9.16667V7.70004ZM11.8333 7.70004H10.5V5.03337H11.8333V7.70004ZM9.16667 11.9667H7.83333V9.30004H9.16667V11.9667ZM6.5 11.9667H5.16667V9.30004H6.5V11.9667ZM6.5 7.70004H5.16667V5.03337H6.5V7.70004Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
